import {SupportActionTypes} from "./SupportActionConstants"
import authService from "../../auth/AuthService";

const setWSID = (wsid) => ({
    type: SupportActionTypes.ENTER_WSID,
    payload: {wsid},
});

const updateRegionSelect = (selectedOption) => ({
    type: SupportActionTypes.REGION_SELECTED,
    payload: {selectedOption}
});

const getTXLogs = (authToken, wsid) => ({
    type: SupportActionTypes.GET_TX_LOGS,
    payload: {authToken, wsid}
});

const getDebugFiles = (authToken, wsid) => ({
    type: SupportActionTypes.GET_DEBUG_FILES,
    payload: {authToken, wsid}
});

const loadTXLogs = (txLogs) => ({
    type: SupportActionTypes.LOAD_TX_LOGS,
    payload: {txLogs}
});

const loadDebugFiles = (debugFiles) => ({
    type: SupportActionTypes.LOAD_DEBUG_FILES,
    payload: {debugFiles}
});

const displayDebugFilesModal = () => ({
    type: SupportActionTypes.DISPLAY_DEBUG_FILES
});

const closeTxModal = () => ({
    type: SupportActionTypes.CLOSE_TX_MODAL,
});

const closeDebugModal = () => ({
    type: SupportActionTypes.CLOSE_DEBUG_MODAL,
});

const unmountTxDebugLogs = () => ({
    type: SupportActionTypes.CLEAR_TX_DEBUG_DETAILS
});


/**
 * ACTION TO CLEAR THE TX- DEBUG DETAILS FROM REDUX STORE
 * */
export function unmountTxDebugLogsPage() {
    return (dispatch) => {
        dispatch(unmountTxDebugLogs());
    }
}


/**
 * ACTION TO SET THE WSID TO REDUX STATE FOR SEARCH
 * */
export function setWSIDToState(wsid) {
    return (dispatch) => {
        dispatch(setWSID(wsid))
    };
}

/**
 * ACTION TO DISPLAY DEBUG FILES MODAL.
 * */
export function showDebugModal() {
    return (dispatch) => {
        dispatch(displayDebugFilesModal())
    }
}

/**
 * ACTION TO TOGGLE THE MODALS. USED ONLY TO CLOSE THEM.
 * */
export function toggleModal(type) {
    return (dispatch) => {
        type === "tx"
            ? dispatch(closeTxModal())
            : dispatch(closeDebugModal())
    }
}

/**
 * ACTION TO DISPLAY TX LOGS
 * */
export function displayTxLogs(txLogs) {
    return async (dispatch) => {
        dispatch(loadTXLogs(txLogs))

    }
}

/**
 * ACTION TO DISPLAY DEBUG FILES
 * */
export function displayDebugFiles(debugFiles) {
    return async (dispatch) => {
        dispatch(loadDebugFiles(debugFiles))
    }
}

/**
 * ACTION TO SET THE API REGION TO REDUX STATE FOR SEARCH
 * */
export function updateRegionSelection(selectedOption) {
    return (dispatch) => {
        dispatch(updateRegionSelect(selectedOption))
    };
}

/**
 * ACTION TO GET THE TRANSACTION LOGS AND THE
 * DEBUG FILES USING THE WSID.
 * */
export function displayWSIDResult(wsid) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(getTXLogs(authToken, wsid));
        dispatch(getDebugFiles(authToken, wsid))
    }
}

const exports = {
    SupportActionTypes,
}

export default exports;